import { render, staticRenderFns } from "./navButtonsComponent.vue?vue&type=template&id=183243f9&scoped=true"
import script from "./navButtonsComponent.vue?vue&type=script&lang=js"
export * from "./navButtonsComponent.vue?vue&type=script&lang=js"
import style0 from "./navButtonsComponent.vue?vue&type=style&index=0&id=183243f9&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183243f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183243f9')) {
      api.createRecord('183243f9', component.options)
    } else {
      api.reload('183243f9', component.options)
    }
    module.hot.accept("./navButtonsComponent.vue?vue&type=template&id=183243f9&scoped=true", function () {
      api.rerender('183243f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/navButtonsComponent.vue"
export default component.exports